import icons from '../icons';

export const TEST_STATUSES = {
  INCOMPLETE: 'incomplete',
  UNSURE: 'unsure',
  INVALID: 'invalid',
  VALID: 'valid',
};

/* eslint-disable import/no-mutable-exports */
let testStatusOptions = [];

export function loadTestStatuses(locales) {
  testStatusOptions = [
    {
      label: locales.testing.testCard.statusOptions.incomplete,
      value: TEST_STATUSES.INCOMPLETE,
      icon: icons.incomplete,
    },
    {
      label: locales.testing.testCard.statusOptions.unsure,
      value: TEST_STATUSES.UNSURE,
      icon: icons.question,
    },
    {
      label: locales.testing.testCard.statusOptions.invalid,
      value: TEST_STATUSES.INVALID,
      icon: icons.x,
    },
    {
      label: locales.testing.testCard.statusOptions.valid,
      value: TEST_STATUSES.VALID,
      icon: icons.okSmall,
    },
  ];
}

export { testStatusOptions };
export default testStatusOptions;
